import { runCalculatorFloatingAsyncAction } from "../../../Core/Calculator2/Calculator2Compatibility";
import { IForm } from "../../IForm";
import { convertToAbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";

import { ICustomValidationFunctionValidationRunner } from "./ICustomValidationFunctionCallContext";

export class CustomValidationFunctionValidationRunner implements ICustomValidationFunctionValidationRunner {
    readonly #form: IForm;

    public constructor(form: IForm) {
        this.#form = form;
    }

    public validate(nodePath: string): void {
        runCalculatorFloatingAsyncAction(() => this.#form.revalidatePaths([nodePath].map(convertToAbsoluteModelPath)));
    }

    public validateAll(nodePaths: string[]): void {
        runCalculatorFloatingAsyncAction(() => this.#form.revalidatePaths(nodePaths.map(convertToAbsoluteModelPath)));
    }
}
